import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

@Directive({
  selector: '[fzProcessing]',
  standalone: true,
})
export class SharedDirectivesProcessingDirective implements OnChanges {
  @Input('fzProcessing') loading: boolean;
  @Input('fzProcessingPosition') position: string = 'center-center';
  @Input('fzProcessingHideContent') hideContent: boolean = false;

  constructor(private el: ElementRef) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['loading']?.currentValue) {
      // create loading element
      const loadingElement = document.createElement('div');
      loadingElement.setAttribute('data-e2e', 'processing');
      loadingElement.classList.add(
        'processing__root',
        `processing__root--${this.position}`,
      );
      loadingElement.innerHTML = `<span class="dot"></span><span class="dot"></span><span class="dot"></span>`;

      // attach loading element to the host element
      this.el.nativeElement.appendChild(loadingElement);

      // add processing class to host element
      this.el.nativeElement.classList.add(
        'processing',
        ...(this.hideContent ? ['processing--hide-content'] : []),
      );
    } else {
      // remove processing class from host element
      this.el.nativeElement.classList.remove(
        'processing',
        'processing--hide-content',
      );

      // remove loading element from host element
      const loadingElement =
        this.el.nativeElement.querySelector('.processing__root');
      if (loadingElement) {
        this.el.nativeElement.removeChild(loadingElement);
      }
    }
  }
}
